export default __webpack_public_path__ + "static/media/BCM.c8af75ef.png";